import { Toast } from "components/ToastShow/ToastAlert";
import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";





export const getAttachmentViewers = (ownerId ) => http({
    url: ENDPOINTS.Widget.bord,
    method: 'get',
    params: {
        BulletinBoardId: ownerId
    }
}).then(response => response.data)
    .catch(err => {
       return Promise.reject( err);
    })

export const DeleteAttachmentViewers= (attachId ,endpoints) => http({
    url: endpoints,
    method: 'delete',
    params: {
        attachId: attachId
    }

}).then(response => {
    return response.data
}

)


export const GetHelp= () => http({
    url: ENDPOINTS.archive.JobOrganizationalArchiveDetail.help,
    method: 'get',
}).then(response => {
    return response.data
}

)

export const PostAttachmentViewers = (data, ownerId , endpoints ,Name) =>
    http({
        url: endpoints,
        method: 'post',
        params: {
            OwnerId: ownerId,
            fileName:Name
        },
        data: data,
        headers: {
            "content-type": "multipart/form-data",
            Accept: "*/*",
        }
    }).then((res) => {
        return res.data
    }).catch((err) => {
        return Promise.reject( err);
    });
    
export const PutAttachmentViewers = (data, ownerId , endpoints ,id) =>
    http({
        url: endpoints+"Id",
        method: 'put',
        params: {
            Id: id
        },
        data: data,
        headers: {
            "content-type": "multipart/form-data",
            Accept: "*/*",
        }
    }).then((res) => {
        return res.data
    }).catch((err) => {
        return Promise.reject( err);
    });
    


function blobToBase64(blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

export const loadAttachmentViewerBase64 = (attachId , endpoint=null) => http({
   // url: ENDPOINTS.bulletinBoard.file,
   url:endpoint ? endpoint: ENDPOINTS.Widget.bordAttachment,
    method: 'get',
    params: {
        attachId: attachId
    },
    responseType: "blob"
}).then(async(response) => {

    return blobToBase64(response.data)
}).catch((err) => {
  //   
    return Promise.reject( err);
});

export const loadAttachmentViewer = (attachId ) => http({
    url: ENDPOINTS.bulletinBoard.file,
    method: 'get',
    params: {
        attachId: attachId
    },
    responseType: "blob"
}).then(response => {
    return response.data
}).catch((err) => {
  //   
    return Promise.reject( err);
});
export const getDownloadUrlAttachmentAsync = (attachId ) => http({
    url: ENDPOINTS.Widget.bordUrl,
    method: 'get',
    params: {
        attachId: attachId
    },
    responseType:"blob"
}).then(response => {
    return response.data
}).catch((err) => {
  //   
    return Promise.reject( err);
});



export const UpdateAttachmentDetails = (data ) => http({
    url: ENDPOINTS.bulletinBoard.attachment,
    method: 'put',
    data:data
}).then(response => {
    return response.data;
}).catch((err) => {
    return Promise.reject( err);
});



export const getAttachmentDetail = (Id ) => http({
    url: ENDPOINTS.bulletinBoard.attachment,
    method: 'get',
    params:{
        attachId : Id
    }
}).then(response => {
    return response.data;
}).catch((err) => {
    return Promise.reject( err);
});



